import {
  SEARCH_REQUEST,
  SEARCH_REQUEST_SUCCESS,
  SEARCH_REQUEST_FAILURE,
  SEARCH_REQUEST_SUCCESS_ALL,
  SEARCH_REQUEST_CLEAR,
} from '../constants/ActionTypes';

const initialState = { loaded: true, loadedAll: false, resultData: [] };
export default function EmployeeSearch(state = initialState, action) {
  switch (action.type) {
    case SEARCH_REQUEST:
      return {
        ...state,
        loaded: false,
        loadedAll: false,
        error: null,
        query: action.query,
      };
    case SEARCH_REQUEST_SUCCESS:
      return {
        ...state,
        loaded: true,
        error: null,
        resultData: action.resultData,
      };
    case SEARCH_REQUEST_SUCCESS_ALL:
      return {
        ...state,
        loadedAll: true,
        loaded: true,
        error: null,
        resultData: action.resultData,
      };
    case SEARCH_REQUEST_FAILURE:
      return {
        ...state,
        loaded: true,
        error: action.error,
        resultData: [],
      };
    case SEARCH_REQUEST_CLEAR:
      return {
        ...state,
        resultData: [],
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/EmployeeSearch.js